import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Hero from './Hero';
import Features from './Features';
import Cta from './Cta';
import Gallery from './Gallery';
import Videos from './Videos';
import VirtualTour from './VirtualTour';
import VirtualTourSuite from './VirtualTourSuite';
import Neighborhood from './Neighborhood';
import Filters from './Filters';
import Map from './Map';
import NotFound from '../../NotFound/NotFound';

class Detail extends Component {
    constructor(props) {
        super(props);

        let property = this.getProperty();

        if (!property) {
            property = this.checkTokenizedId();
        }

        this.state = {
            selectedPlaceType: 'restaurant',
            handleAvailabilities: null,
            property: property || null,
            isLoaded: false,
        };
    }

    // set the selected Google Maps places and filters to a type such as restaurants, bars & nightlife, and so on.
    onUpdateSelectedPlaceType = val => {
        this.setState({
            selectedPlaceType: val,
        });
    };

    // scroll state for the availabilities component
    scrollToAvailabilities = val => {
        this.setState({
            handleAvailabilities: val,
        });
    };

    setLoaded = () => {
        this.setState({
            isLoaded: true,
        });
    };

    // get the matching property based on the slug
    getProperty = () => {
        const property = this.props.properties ? this.props.properties.find(property => property.slug === this.props.currentPath) : null;

        return property;
    };
    checkTokenizedId() {
        const currentPath = this.props.currentPath;

        const propertyByTokenizedId = this.props.properties
            ? this.props.properties.find(
                  property =>
                      property.tokenized_id === currentPath ||
                      property.tokenized_ids_secondary.includes(currentPath) ||
                      property.tokenized_ids_spaces.includes(currentPath)
              )
            : null;

        if (!propertyByTokenizedId) {
            return null;
        }
        return propertyByTokenizedId;
    }

    componentDidMount() {
        let property = this.getProperty();

        if (!property) {
            property = this.checkTokenizedId();
            if (property) this.props.history.push(`/office/${property.slug}`);
        }

        this.setState({
            property,
        });

        // if the hash is equal to '#availabilities' scroll the window to the availabilities component
        if (this.props.history.location.hash === '#availabilities') {
            this.scrollToAvailabilities();
        }

        const timeoutMs = this.props.screen.isMobile ? 2500 : 1300;

        setTimeout(() => {
            this.setLoaded();
        }, timeoutMs);
    }
    componentDidUpdate() {
        let property = this.getProperty();

        if (!property) {
            property = this.checkTokenizedId();
            if (property) this.props.history.push(`/office/${property.slug}`);
        }

        // if handleAvailabilities is not null and there are available spaces scroll the window to the availabilities component
        if (this.state.handleAvailabilities !== null && property.spaces.length !== 0) {
            this.setState({
                handleAvailabilities: null,
            });
            setTimeout(() => {
                this.availabilities.simulateClick();
            }, 1000);
        }
    }

    render() {
        const property = this.state.property;
        const collection = this.props.collection;
        const { isLoaded } = this.state;

        if (!property) {
            return <NotFound />;
        }

        return (
            <div className="property-detail">
                <Helmet>
                    <title>{property.seo_title}</title>
                    <meta name="description" property="og:description" content={property.web_description} />
                </Helmet>
                <Hero property={property} />
                <Features property={property} />
                <Cta scrollToAvailabilities={this.scrollToAvailabilities} property={property} collection={collection} />
                {isLoaded && <Gallery screen={this.props.screen} property={property} />}
                <Videos property={property} />
                {/* <VirtualTour property={property} /> */}
                {property.property_map && <Neighborhood />}
                {/*isLoaded && <Filters selectedPlaceType={this.state.selectedPlaceType} onUpdateSelected={this.onUpdateSelectedPlaceType.bind(this)} />*/}
                {isLoaded && property.property_map  && (
                    <div className="property-detail-map">
                        {/* <Map property={property} selectedPlaceType={this.state.selectedPlaceType} /> */}     
                        <div className="section">
                            <div className="container">
                                <img alt="Property Map" src={`${process.env.RAZZLE_ASSET_URL}${property.property_map}`} />    
                            </div>
                        </div>
                    </div>
                )}
                {isLoaded && <VirtualTourSuite property={property} />}

                {property.leasing_information_link && <div className="leasing-info">
                    <div className="section">
                        <div className="container">
                            <div className="columns">
                                <div className="column is-offset-1 is-6-tablet is-7-desktop is-7-widescreen">
                                    <div className="big-title border-left-yellow">LEASING INFO</div>
                                </div>
                                <div className="column">
                                    <a className="button" target="_blank" rel="noreferrer" href={property.leasing_information_link}>
                                        <span>{property.leasing_information}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}

            </div>
        );
    }
}

Detail.propTypes = {
    selectedPlaceType: PropTypes.string,
    onUpdateSelected: PropTypes.func,
    history: PropTypes.object,
    properties: PropTypes.array.isRequired,
    collection: PropTypes.array,
    currentPath: PropTypes.string.isRequired,
    screen: PropTypes.object.isRequired,
    handleClear: PropTypes.func.isRequired,
};

export default connect(
    ({ screen, content }) => ({
        screen,
        collection: content.collection,
        properties: content.properties,
    }),
    null
)(Detail);
